<template>
  <div
    class="sidebar-button-container" :class="{isOpen}">
    <router-link class="button-link" :to="{ name: link ? link : '' }">
      <div @click="handleClick" class="button mb-1" :class="{
        active: ($route.name === link) || $route.path.includes(link) || (submenu && isOpen) || activeLink,
        selected: ($route.name === link) || $route.path.includes(link) || activeLink,
        expanded: appStore.sidebar || (isOpen && submenu),
      }" style="z-index: 10">
        <div :class="submenu ? 'icon-button-with-submenu' : 'icon-button'"
          v-tooltip="{ placement: 'right', theme: 'nonius-tooltip', content: title, disabled: appStore.sidebar }"
          ref="tooltipBtn">

          <template v-if="submenu">
            <div class="d-flex align-items-center">
              <img class="menu-icon" v-if="icon" :src="require(`@/assets/svg/${icon}.svg`)" alt="" />
              <div :class="{ active: $route.path.includes(link) || isOpen || activeLink }" class="menu-text"
                v-show="appStore.sidebar || isOpen">
                {{ title }}
              </div>
            </div>
            <img :src="require(`@/assets/svg/Icon_arrow_down.svg`)" alt="" class="menu-arrow"
              v-show="appStore.sidebar || isOpen" :style="isOpen ? 'transform: rotateY(180deg)' : ''" />
          </template>

          <template v-else>
            <img class="menu-icon" v-if="icon" :src="require(`@/assets/svg/${icon}.svg`)" alt="" />
            <div :class="{ active: $route.path.includes(link) }" class="menu-text" v-show="appStore.sidebar">
              {{ title }}
            </div>
          </template>
          
        </div>
      </div>
      <Transition name="slide-up">
        <div v-if="submenu && isOpen" class="submenu-container"
          :style="{ '--submenu-height': (submenu.length * 40) + 'px' }">
          <template v-for="item in submenu" :key="item.title">
            
            <router-link 
              v-if="!item.roles || item.roles.includes(appStore.getCurrentRole)" 
              :to="{ name: item.link }"
            >
              <div class="button active" :class="{ expanded: appStore.sidebar || isOpen }">
                <div class="icon-button"
                  v-tooltip="{ placement: 'right', theme: 'nonius-tooltip', content: item.title, disabled: appStore.sidebar }">
                  <span class="circle-container">
                    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"
                      v-if="$route.path.includes(item.link)">
                      <ellipse cx="8.07271" cy="8.03872" rx="4.8" ry="4.76599" fill="#4195FF" />
                      <ellipse cx="8.12823" cy="8.09383" rx="3.22284" ry="3.2" fill="#F4F4F4" />
                    </svg>
                  </span>
                  <div class="menu-text active" v-show="appStore.sidebar || isOpen">
                    {{ item.title }}
                  </div>
                </div>
              </div>
            </router-link>

          </template>
        </div>
      </Transition>
    </router-link>
  </div>
</template>

<script>
import { useAppStore } from '@/store';

export default {
  emits: ['toggle'],
  setup() {
    const appStore = useAppStore();
    return { appStore };
  },
  props: {
    title: String,
    icon: String,
    link: String,
    index: Number,
    submenu: Array,
    isOpen: Boolean,
  },
  data() {
    return { activeLink: false };
  },
  watch: {
    '$route.path': {
      handler() {
        if (this.submenu) {
          const foundItem = this.submenu.filter(item => this.$route.path.includes(item.link))[0];
          this.activeLink = !!foundItem;
        }
      },
      immediate: true,
    },
  },
  methods: {
    handleClick() {
      if (this.appStore.sidebar) {
        this.$emit('toggle');
      } else if (this.submenu) {
        this.$emit('toggle');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.button {
  background-color: #484848;
  width: 44px;
  height: 40px;
  display: flex;
  justify-content: center;
  place-items: center;
  transition-property: width;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 0.2s;
  overflow: hidden;
}

.icon-button {
  height: 38px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.icon-button-with-submenu {
  height: 38px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.button.expanded {
  width: 183px;
  justify-content: flex-start;
  padding: 0 12px;
}

.button.expanded .icon-button {
  width: auto;
  text-transform: capitalize;
}

.button.expanded .icon-button-with-submenu {
  width: 100%;
  text-transform: capitalize;
}

.menu-arrow {
  transform: rotateX(180deg);
  filter: invert(79%) sepia(9%) saturate(11%) hue-rotate(314deg) brightness(91%) contrast(92%);
}

.menu-text {
  text-wrap: wrap;
  text-align: left;
  font-size: 14px;
  font-weight: 600;
  width: 122px;
  line-height: 1;
  letter-spacing: 0.5px;
  color: #b5b5b5;
  padding-left: 8px;
}

.menu-text.active {
  color: #484848;
}

a,
a:hover,
a:visited,
a:active {
  color: inherit;
  text-decoration: none;
}

a:hover .button {
  background-color: #595959;
}

a .button.active {
  background-color: #F4F4F4;
  color: black;
}

/* This applies the dark filter */
.button.active img {
  filter: brightness(0.6);
}

/* This applies the BLUE filter, but requires .menu-icon class */
.button.selected img.menu-icon {
  filter: invert(0.5) sepia(1) saturate(5) hue-rotate(175deg);
}

img.menu-arrow {
  transition: .25s transform ease-in-out;
}

.circle-container {
  width: 20px;
  display: flex;
  align-items: center;
  justify-items: center;
}

.slide-up-enter-active {
  transition: max-height 0.2s ease-in;
}

.slide-up-leave-active {
  transition: max-height 0.2s ease-out;
}

.slide-up-enter-to,
.slide-up-leave-from {
  overflow: hidden;
  max-height: var(--submenu-height);
}

.slide-up-enter-from,
.slide-up-leave-to {
  overflow: hidden;
  max-height: 0;
}

.submenu-container a:not(:last-child) .button {
  margin-bottom: .25rem
}

.sidebar-button-container {
  max-width: max-content;
}
.sidebar-button-container .button-link{
  background-color: rgb(237, 237, 237);
  box-shadow: 0 0 10px 0 rgba(33, 33, 33, 0.15);
  display: block;
}
</style>